// import receiveNotification from './receiveNotification'
import getNotifications from './getNotifications'
import connectSocket from './connectSocket'
import disconnectSocket from './disconnectSocket'
import readNotificaion from './readNotificaion'
import fetchNotifications from './fetchNotifications'
import disconnectNotifications from './disconnectNotifications'

export default{
  getNotifications,
  connectSocket,
  disconnectSocket,
  readNotificaion,
  fetchNotifications,
  disconnectNotifications
}



// WEBPACK FOOTER //
// ./src/services/notification/index.js